import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import {
  Memberships,
  UpdateWelcomeEmailPayload,
} from "../../types/Types";

export function useUpdateWelcomeEmail() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      payload,
    }: {
      id: number;
      payload: UpdateWelcomeEmailPayload;
    }) => {
      const res = await axiosInstance.put<Memberships>(
        getAPIURL(`/Membership/${id}/welcome-email`),
        payload,
      );
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["memberships"] });
    },
  });
}
